module.exports = __webpack_public_path__ + "static/media/m_sf_9.8e4cb2c6.png";